import React, { useState, useEffect } from 'react';
import DatePick from 'react-datepicker';
import CustomDateInput from './CustomDateInput';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

const DatePicker = (props) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [textDate, setTextDate] = useState('')
  const [loadValue, setLoadValue] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const momentDateFormat = "MM/DD/YYYY";

  useEffect(() => {
    if (props && props.value && !loadValue) {
      let propDate = new Date(props.value);
      let momentDate = moment(propDate).format(momentDateFormat);
      setLoadValue(true);
      setTextDate(momentDate.toString());
      setSelectedDate(propDate);
    }
  }, [props, selectedDate, loadValue])

  useEffect(() => {
    if (props && props.error) {
      if (Object.keys(props.error).length) {
        Object.entries(props.error).forEach(([key, value]) => {
          if (key === props.name) {
            setErrorMsg(value.toString());
          }
        })
      } else if (errorMsg.length) {
        setErrorMsg('');
      }
    }
  }, [props, errorMsg])

  const onChangeRaw = (value) => {
    setTextDate(value);
    let newDate = moment(value, momentDateFormat, true);
    if (newDate.isValid()) {
      finalizeNewDate(newDate.toDate());
    }
  }

  const onDateChange = (date) => {
    let momentDate = moment(date).format(momentDateFormat);
    setTextDate(momentDate);
  
    finalizeNewDate(date);
  }

  const finalizeNewDate = (date) => {
    setSelectedDate(date);

    let formattedDate = moment(date).startOf('day').format('YYYY-MM-DD');
    props.onChange(props.name, formattedDate);
  }

  return (
    <div className={ `coral-Form-fieldwrapper ${(errorMsg && errorMsg.length) ? 'error' : ''}` }>
      <label className="coral-Form-fieldlabel">
        { props.label }
        <small className="required-label">{ props['data-required'] ? `${ props['data-required-label'] }`: '' }</small>
      </label>
      <DatePick
        selected={ selectedDate }
        onChange={ date => onDateChange(date) }
        onChangeRaw={ event => onChangeRaw(event.target.value) }
        customInput={ 
          <CustomDateInput 
            inputName={ props.name }
            displayDate={ textDate }
            onChangeRaw={ event => onChangeRaw(event.target.value) }
            disableField={ props.disabled }
          />
        }
      />
      <span className={ `${(errorMsg && errorMsg.length) ? 'help-block field-error' : ''}` }>{ errorMsg }</span>
    </div>
  )
}

export default DatePicker;